<template>
  <div class="tablearea">
    <div class="btn_area">
      <div v-if="mode=='edit'" class="btn_area_left">
        *기본값SET
        <select :key="selectKey" @change="settingAddRowInfo($event)">
          <option v-for="(experiment,idx) in getFilteredExperimentList"
                  :key="idx" :value="experiment.experimentId">
            {{ experiment.experimentName }}
          </option>
        </select>
        <a v-if="mode=='edit'" class="btn_type4" @click="addRowWithValues(position.last)">ROW추가</a>
        <!--박수형 박사님 요청 더미 데이터 입력 버튼-->
        <a 
          v-if="mode=='edit' && user != null && user?.loginId == 'SOOHYUNGPARK2'" 
          class="btn_type4" 
          style="display: inline-flex; align-items: center; gap: 8px;"
          @click="addSampleRowWithValues(position.last, sampleRowCount)"
        >
          <span>임시데이터</span>
          <input 
            v-model.number="sampleRowCount" 
            type="number" 
            min="1" 
            max="15"
            style="width: 50px; height: 28px; padding: 4px 8px; border: 1px solid #ddd; border-radius: 4px; text-align: center; font-size: 14px;"
            @click.stop
          />
          <span>개 추가</span>
        </a>
      </div>
      <div class="btn_area_right">
<!--        <a class="btn_type6" @click="callNodeMarkSetting">노드 표시 설정</a>-->
        <div v-if="mode=='edit'" class="checkbox_toggle">
            <input class='tg-input tg-eff' id='checkbox_toggle' type='checkbox' checked="unchecked" @change="toggleAutoSave" ref="checkbox_toggle">
            <label class='tg-btn' for='checkbox_toggle'></label>
        </div>
        <a v-if="mode=='edit'" class="btn_type1" @click="saveData">저장</a>
<!--        <a class="btn_type1" @click="jsonHandler">TEST</a>
        <a class="btn_type1" @click="callKeshImageService">KESH</a>-->
<!--        <a v-if="mode=='edit' || 'readOnly'" class="btn_type1" @click="jsonHandler">JSONDATA</a>-->
<!--        <a v-if="mode=='edit'" class="btn_type2">취소</a>-->
        <a v-if="mode=='edit'" class="btn_type4" @click="callVersionHistory">버전이력</a>
        <a v-if="mode=='edit'" class="btn_type3" @click="callResultConfrim">엑셀업로드</a>
        <a v-if="mode=='edit'" class="btn_type3" @click="excelTemplateDownLoad">엑셀다운로드</a>
        <a v-if="mode=='edit'" class="btn_type3" @click="excelVocabClassDownLoad">엑셀다운로드(표준어휘 체계)</a>
        <a v-if="mode=='readOnly'" @click="editExperiment" class="btn_type5">수정모드</a>
        <a v-if="mode=='edit'" @click="endEditExperiment" class="btn_type5">읽기모드</a>
      </div>
    </div>
    <HotTableMain
        ref="handsomeRef"
        :settings="hotSettings"
        :licenseKey="'6c578-61cf1-e8cf5-b453c-1f850'"
    ></HotTableMain>
    <div v-show="editStatusAlert" class="modalPopupLayout active">
      <div class="contentWrap">
        <h2 class="title" style="text-align: center">{{ editStatusTitle }}</h2>
        <div class="content">
          <p class="content" style="text-align: center; width: 300px" v-html="editStatusContent"></p>
        </div>
        <div class="ctrl" style="margin-top : 20px">
          <button class="sm_btn color_2" @click="$router.go( $router.currentRoute )">확인</button>
        </div>
      </div>
    </div>
    <Loading :visible="loading || savingLoading"/>
  </div>
</template>

<script>

import { v4 } from "uuid";
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
const CommNew = createNamespacedHelpers('CommNew');
const ProcessEditor = createNamespacedHelpers('ProcessEditor')
import { HotTable } from '@handsontable/vue';
import { ContextMenu } from 'handsontable/plugins/contextMenu';
import { registerAllModules } from 'handsontable/registry';
import { api as viewerApi } from "v-viewer"
import Handsontable from "handsontable";
import {
  settingHeader,
  groupBy,
  checkActiveRow,
  exportToJson,
  getFormattedTodayDate,
  initiateUniqueID,
  generateUniqueID,
  DEFAULT_COL_INDEX,
  COL_PREFIX,
  PROPERTY_TYPE,
} from "@/util/HubHandsonTable";
import Loading from '@common/loading.vue';
registerAllModules();

export default {
  beforeDestroy () {
    window.removeEventListener( 'keydown' , this.keydownHandler ) ;
    if ( this.user.name != 'AxiosError' ) {
      this.stopAutoSave();
      this.cleanup();
    }
  } ,
  props :{
    editKey : {
      type : String,
      default : null
    },
    mode : {
      type : String,
      default : "readOnly"
    },
  },
  components : {
    HotTableMain : HotTable,
    Loading,
  } ,
  data() {
    return {
      loading : false,
      savingLoading : false, // 따로 사용
      sampleRowCount : 5, // 임시 데이터 저장 개수
      checkTemporaryAccount : true, // 임시 계정 저장시 확인할지 값
      PROPERTY_TYPE : PROPERTY_TYPE,
      sourceImageObjects : [], //이미지 객체
      lastClickTime : null,
      isSaving : false, // 저장로직 실행여부
      rowChange : false, // 로우변경사항 여부
      position : {last : 'last', above : 'above', below : 'below'},
      editStatusAlert : false,
      editStatusTitle : "",
      editStatusContent : "",
      networkErrorCount : 0, // 네트워크 오류 횟수
      maxNetworkErrors: 5, // 네트워크 오류 최대 허용 횟수
      pollingEndSwitch : false,  // 폴링 종료 스위치
      isAutoSaveEnabled: true, // 자동 저장 활성화 상태
      autoSaveInterval: 10000, // 10초
      autoSaveTimer: null,     // 자동 저장 타이머
      selectedAddRowInfo : [],
      selectKey : 0,
      selectOption : null, //실헙타입
      hotInstance : null, // Handsontable 인스턴스
      cellMetaBackup : {}, //메타데이터 백업 저장소
      cellsFromDB: [], // 셀 데이터
      mappingCellMetaData : null, //초기 데이터 불러올때 metaData 세팅용. 그 이후에는 col,row가 유동적으로 변경될 수 있기때문에 사용X
      changeStack : [],
      changeStackIndex: new Map(),
      changeVersion: 0,
      rowChangeVersion: 0,
      fileCopyStack: [],  // 파일 복사 요청 스택 추가
      copiedFileCells: [],
      hotSettings: {
        data : [],
        width: '99%',
        height: '89%',
        autoWrapRow: true,
        autoWrapCol: true,
        rowHeaders: true,
        colHeaders: true,
        //TODO enable the column menu 필터 적용 시 row active가 날라가는 문제
        filters: true, // enable filtering
        dropdownMenu:  ['filter_by_condition', 'filter_by_value', 'filter_action_bar'],
        autoColumnSize: {
          useHeaders: true, // 헤더 내용을 기준으로 자동 크기 조정
        },
        contextMenu: {
          callback: ((key, selection, clickEvent)=> {
            if(key == 'remove_row'){
              this.markRowChanged();
            }
            console.log(`Key: ${key}, Selection: ${JSON.stringify(selection)}, Click Event: ${JSON.stringify(clickEvent)}`);
            //console.log('getData = ', this.getData());
            //console.log('getSourceData = ', this.getSourceData());
          }),
          items: {
            viewerApi: {
              name: '이미지뷰어',
              hidden: (() => {
                // 다중 셀이 선택되었는지 확인
                const selectedRange = this.hotInstance.getSelectedRange();
                if(!selectedRange){
                  return true;
                }
                // 시작 셀과 끝 셀이 같은 경우(즉, 단일 셀 선택)
                return ((selectedRange[0].from.row !== selectedRange[0].to.row || selectedRange[0].from.col !== selectedRange[0].to.col)
                    || this.hotInstance.getSettings().columns[selectedRange[0].from.col].propertyType != this.PROPERTY_TYPE.IMAGE.value)
              }),
              callback: (async (key, selection) => {
                const {row, col} = selection[0].start;
                const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const cellColMeta = this.hotInstance.getColumnMeta(col)
                //console.log('rowId : ',rowId,'// selectedColMeta :',selectedColMeta)
                const mappingKey = this.$route.query.processId + "_" + cellColMeta.data.replace(COL_PREFIX,"") + "_" + rowId;

                await this.imageViewerLoad(mappingKey);
              })
            },
            //정렬기능으로 인한 주석.
/*            addAboveRow: {
              name: '선택한 기본값SET으로 상단 ROW추가',
              hidden: (() => {
                const selectedRange = this.hotInstance.getSelectedRange();
                if(!selectedRange){
                  return true;
                }
                // Edit 모드일경우만 && 단일행일경우
                return selectedRange[0].from.row !== selectedRange[0].to.row
                      || this.mode == "readOnly";
              }),
              callback: (_ => {
                this.addRowWithValues(this.position.above);
              })
            },
            addBelowRow: {
              name: '선택한 기본값SET으로 하단 ROW추가',
              hidden: (() => {
                const selectedRange = this.hotInstance.getSelectedRange();
                if(!selectedRange){
                  return true;
                }
                // Edit 모드일경우만 && 단일행일경우
                return selectedRange[0].from.row !== selectedRange[0].to.row
                      || this.mode == "readOnly";
              }),
              callback: (_ => {
                this.addRowWithValues(this.position.below);
              })
            },*/
            alignment :{},
            remove_row:{
              name: '선택ROW 삭제',
              hidden: (() => {
                // Edit 모드일경우만
                return this.mode == "readOnly";
              }),
            },
            /*remove_row: {
              name: '선택ROW 삭제',
              hidden: (() => {
                // 다중 로우가 선택되었는지 확인
                const selectedRange = this.hotInstance.getSelectedRange();

                // 시작/끝이 같은 경우(즉, 단일 로우 선택)
                return selectedRange[0].from.row !== selectedRange[0].to.row ||
                this.mode == "readOnly";
              }),
              callback: (async (key, selection) => {
                //다중행 삭제
                const selectedRange  = this.hotInstance.getSelectedRange();  // 현재 선택된 셀의 영역 정보를 가져옵니다.
                if (selectedRange) {
                  const rowsToRemove = new Set();

                  // 각 선택된 범위에서 row 범위를 계산
                  selectedRange.forEach(range => {
                    const startRow = Math.min(range.from.row, range.to.row);
                    const endRow = Math.max(range.from.row, range.to.row);

                    for (let row = startRow; row <= endRow; row++) {
                      rowsToRemove.add(row);
                    }
                  });

                  const sortedRows = Array.from(rowsToRemove).sort((a, b) => b - a);
                  const confirmDelete = await confirm(`선택된 ${sortedRows.length}행을 삭제하시겠습니까?`);
                  if (confirmDelete) {
                    // 수집된 행을 삭제 (뒤에서부터 삭제하여 인덱스에 영향 없음)
                    this.hotInstance.batch(()=>{
                      sortedRows.forEach(row => this.hotInstance.alter('remove_row', row));
                    });
                  }
                  this.rowChange = true;
                }
              })
            },*/
            separator1: Handsontable.plugins.ContextMenu.SEPARATOR,
            cellHistory: {
              name: 'CELL 변경이력 조회',
              hidden: (() => {
                // 다중 셀이 선택되었는지 확인
                const selectedRange = this.hotInstance.getSelectedRange();
                if(!selectedRange){
                  return true;
                }
                // 시작 셀과 끝 셀이 같은 경우(즉, 단일 셀 선택)
                return (selectedRange[0].from.row !== selectedRange[0].to.row || selectedRange[0].from.col !== selectedRange[0].to.col);
              }),
              callback: ((key, selection) => {
                const {row, col} = selection[0].start;
                const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const cellColMeta = this.hotInstance.getColumnMeta(col);
                console.log('rowId : ',rowId,'// selectedColMeta :',cellColMeta);
                if((rowId == null && rowId == '') || (cellColMeta.data == null && cellColMeta.data == '')){
                  alert("오류가 발생했습니다. 관리자에게 문의해주세요.");
                  return;
                }
                this.setSaveHistoryObj({
                  openFlag: true,
                  dataObj: {
                    row : row,
                    col : col,
                    rowId: rowId,
                    colId : cellColMeta.data,
                    nodeName : cellColMeta.nodeName,
                    colName : cellColMeta.name,
                    tagType : cellColMeta.tagType,
                    processPropertyType : cellColMeta.processPropertyType,
                    propertyType : cellColMeta.propertyType
                  }
                });
              })
            },
            uploadFile: {
              name: '첨부파일',
              hidden: (() => {
                // 다중 셀이 선택되었는지 확인
                const selectedRange = this.hotInstance.getSelectedRange();
                if(!selectedRange){
                  return true;
                }
                // 시작 셀과 끝 셀이 같은 경우(즉, 단일 셀 선택)
                return (selectedRange[0].from.row !== selectedRange[0].to.row || selectedRange[0].from.col !== selectedRange[0].to.col)
                    || ( this.hotInstance.getSettings().columns[selectedRange[0].from.col].propertyType != this.PROPERTY_TYPE.FILE.value
                    && this.hotInstance.getSettings().columns[selectedRange[0].from.col].propertyType != this.PROPERTY_TYPE.IMAGE.value )
              }),
              callback: ((key, selection) => {
                const {row, col} = selection[0].start;
                const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const cellColMeta = this.hotInstance.getColumnMeta(col)
                //console.log('rowId : ',rowId,'// cellColMeta :',cellColMeta)
                const mappingKey = this.$route.query.processId + "_" + cellColMeta.data.replace(COL_PREFIX,"") + "_" + rowId;
                this.callFileUploadPop(row, col, mappingKey, cellColMeta);
              })
            },
          }
        },
        beforeCopy: (data, coords) => {
          this.copiedFileCells = [];

          coords.forEach(coord => {
            const startRow = coord.startRow;
            const endRow = coord.endRow;
            const startCol = coord.startCol;
            const endCol = coord.endCol;

            for (let row = startRow; row <= endRow; row++) {
              for (let col = startCol; col <= endCol; col++) {
                const cellColMeta = this.hotInstance.getColumnMeta(col);

                if (
                    (cellColMeta.propertyType === this.PROPERTY_TYPE.FILE.value ||
                    cellColMeta.propertyType === this.PROPERTY_TYPE.IMAGE.value) && this.mode != 'readOnly') {
                  const rowId = this.hotInstance.getDataAtCell(row, DEFAULT_COL_INDEX.rowId);
                  const sourceMappingKey = this.$route.query.processId + "_" +
                      cellColMeta.data.replace(COL_PREFIX, "") + "_" + rowId;
                  this.copiedFileCells.push({
                    row: row,
                    col: col,
                    sourceMappingKey: sourceMappingKey,
                    propertyType: cellColMeta.propertyType,
                    relativeRow: row - startRow,
                    relativeCol: col - startCol
                  });
                }
              }
            }
          });
        },
        licenseKey: 'non-commercial-and-evaluation',
        // beforePaste 훅 설정
        beforePaste: (data, coords) => {
          const maxCols = this.hotInstance.getSettings().columns.length
          const maxRows = this.hotInstance.countRows(); // 현재 row의 최대 개수 확인

          const startRow = coords[0].startRow;
          const startCol = coords[0].startCol;
          const endRow = coords[0].endRow;
          const endCol = coords[0].endCol;

          const pastedRowCount = data.length;
          const pastedColCount = data[0]?.length || 0;
          
          // 실제 선택된 범위 계산
          const selectedRowCount = endRow - startRow + 1;
          const selectedColCount = endCol - startCol + 1;
          
          // console.log('data 크기:', pastedRowCount, 'x', pastedColCount);
          // console.log('선택 범위:', selectedRowCount, 'x', selectedColCount);

          // 붙여넣기 데이터가 테이블의 최대 row, col을 초과하면 붙여넣기 방지
          if (endRow >= maxRows || endCol >= maxCols) {
            alert("붙여넣기 범위가 테이블 크기를 초과합니다.");
            return false; // 붙여넣기 중단
          }

          // 붙여넣기 데이터 추적 및 changeStack 업데이트
          for(let rowOffset = 0; rowOffset < selectedRowCount; rowOffset++) {
            for(let colOffset = 0; colOffset < selectedColCount; colOffset++) {
              const targetRow = startRow + rowOffset;
              const targetCol = startCol + colOffset;

              if (targetRow < maxRows && targetCol < maxCols) {
                const dataRowIndex = rowOffset % pastedRowCount;
                const dataColIndex = colOffset % pastedColCount;
                const cellValue = data[dataRowIndex][dataColIndex];
                //const oldValue = this.hotInstance.getDataAtCell(targetRow, targetCol); // 기존 값
                const rowId = this.hotInstance.getDataAtCell(targetRow,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const experimentId = this.hotInstance.getDataAtCell(targetRow,DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기
                const cellColMeta = this.hotInstance.getColumnMeta(targetCol);
                
                if((cellColMeta.propertyType === this.PROPERTY_TYPE.FILE.value || 
                   cellColMeta.propertyType === this.PROPERTY_TYPE.IMAGE.value) && this.mode != 'readOnly') {
                  
                  // dataRowIndex, dataColIndex로 찾기
                  const copiedFileInfo = this.copiedFileCells?.find(
                    copied => copied.relativeRow === dataRowIndex && 
                             copied.relativeCol === dataColIndex
                  );
                  
                  if(copiedFileInfo && copiedFileInfo.propertyType == cellColMeta.propertyType) {
                    const targetMappingKey = this.$route.query.processId + "_" + 
                                            cellColMeta.data.replace(COL_PREFIX, "") + "_" + rowId;
                    
                    this.addFileCopyStack(
                      copiedFileInfo.sourceMappingKey,
                      targetMappingKey,
                      experimentId,
                      rowId,
                      cellColMeta.data,
                      cellColMeta.propertyType,
                      targetRow,
                      targetCol
                    );
                    
                    this.hotInstance.setDataAtCell(targetRow, targetCol, cellValue);
                  }
                } else {
                  // 일반 셀은 기존 로직대로 처리
                  if(!cellColMeta.readOnly) {
                    this.addChangeStack(experimentId, rowId, cellColMeta.data, cellValue);
                  }
                }
              }
            }
          }
        },
        afterOnCellMouseDown: (event, coords) => {
          const row = coords.row;
          const col = coords.col
          if (row < 0 && col >= 0) {
            // 해당 열의 메타정보를 가져옵니다.
            const columnInfo = this.hotInstance.getSettings().columns[col];
            if (columnInfo.key) {
              this.DIAGRAM.nodes.each(node => {
                node.isSelected = node.data.key === columnInfo.key;
              });
            }
            console.log(`========================================`);
            console.log(`Selected Header [Column ${col}] - Header Label:`, columnInfo.name,` || Column Meta:`, columnInfo);
            console.log(`========================================`);
          } else if(col < 0 && row >= 0){
            // 해당 row의 메타정보를 가져옵니다.
            const rowLabel = this.hotInstance.getRowHeader(row);
            console.log(`#####################`);
            console.log(`Selected Header [Row ${row}] - Header Label:`, rowLabel);
            console.log(`####################`);
          }else if (row >= 0 && col >= 0) {
            const columnInfo = this.hotInstance.getSettings().columns[col];
            if (columnInfo.key) {
              this.DIAGRAM.nodes.each(node => {
                node.isSelected = node.data.key === columnInfo.key;
              });
            }
            // 선택한 셀의 source데이터
            const rowId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.rowId);//rowId 가져오기
            const experimentId = this.hotInstance.getDataAtCell(row,DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기
            console.log(`-------------------------------------------`);
            console.log(`Selected cell [${row}, ${col}] - rowId:`, rowId, ` || experimentId:`, experimentId);

            if (event.button === 0) {
              const now = new Date().getTime();
              if (this.lastClickTime != null && (now - this.lastClickTime < 300)) {
                //console.log('더블클릭한 셀:', coords.row, coords.col);
                const rowId = this.hotInstance.getDataAtCell(row, DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const cellColMeta = this.hotInstance.getColumnMeta(col)
                //console.log('rowId : ',rowId,'// cellColMeta :',cellColMeta)
                const mappingKey = this.$route.query.processId + "_" + cellColMeta.data.replace(COL_PREFIX, "") + "_" + rowId;
                switch (cellColMeta.propertyType) {
                  case PROPERTY_TYPE.IMAGE.value :
                    // Promise를 사용하여 비동기 처리 => async/await 처리시 handsontable 기본동작인 컬럼전체선택이 동작하지않음.
                    this.imageViewerLoad(mappingKey)
                      .then(() => {
                        console.log("Image loading completed.");
                        // 추가 처리 (이미지 로딩 후 필요한 작업)
                      })
                      .catch(error => {
                        console.error("Error loading image:", error);
                      });
                    break;
                  case PROPERTY_TYPE.FILE.value :
                    this.callFileUploadPop(row, col, mappingKey, cellColMeta);
                    break;
                }
              }
              this.lastClickTime = now;
            }
          }
        },
        afterRowMove: (movedRows, finalIndex, dropIndex, movePossible, orderChanged) => {
          this.markRowChanged();
        },
        afterChange: (async (changes, source) => {
          // revert/loadData는 바로 무시
          if (source === 'revert' || source === 'loadData') {
            return;
          }

          // undo/redo(Ctrl+Z)도 추적하여 되돌린 값이 changeStack에 반영되도록 함(화면=저장값 일치).
          const isUndoRedoSource = source === 'UndoRedo.undo' || source === 'UndoRedo.redo';
          // 체크해야 할 source 타입들
          const sourcesToCheck = ['edit', 'CopyPaste.paste', 'Autofill.fill', 'UndoRedo.undo', 'UndoRedo.redo'];

          if (sourcesToCheck.includes(source) && changes) {
            // 변경해야 할 셀 찾기
            const cellsToCheck = changes.filter(([row, prop, oldValue, newValue]) => {
              return this.checkTemporaryAccount &&
                     this.user?.loginId == 'SOOHYUNGPARK2' &&
                     oldValue != null &&
                     oldValue != "";
            });

            // 변경할 셀이 있으면 한 번만 물어봄
            if (cellsToCheck.length > 0) {
              const confirmed = await window.confirm(
                "<div style='text-align: center;'>" +
                "<p>임시 계정을 사용 중입니다.<br>기존 내용을 변경하시겠습니까?</p>" +
                "<p style='color: #d9534f; font-weight: bold; margin-top: 10px;'>⚠️ 주의</p>" +
                "<p style='font-size: 14px;'>수정 시 기존 값이 빈 값으로 변경되며<br>복구가 매우 어렵습니다.</p>" +
                "</div>", "", {okTitle:"적용"}
              );

              if(!confirmed) {
                // 모든 변경 되돌리기
                for (const [row, prop, oldValue, newValue] of cellsToCheck) {
                  const colIndex = typeof prop === 'number' ? prop : this.hotInstance.propToCol(prop);
                  this.hotInstance.setDataAtCell(row, colIndex, oldValue, 'revert');
                }
                return; // 저장 로직 실행 안함
              }
            }

            // 저장 로직
            changes.forEach(([row, prop, oldValue, newValue]) => {
              const colIndex = this.hotInstance.getSettings().columns.findIndex(col => col.data == prop)
              const cellColMeta = this.hotInstance.getColumnMeta(colIndex);
              // 파일/이미지 셀의 undo/redo는 파일 매핑키 정합성 문제로 changeStack 재동기화에서 제외(일반 셀만 반영)
              const isFileTypeCell = cellColMeta.propertyType == this.PROPERTY_TYPE.FILE.value
                              || cellColMeta.propertyType == this.PROPERTY_TYPE.IMAGE.value;
              if (isUndoRedoSource && isFileTypeCell) return;
              //값이 다르거나 파일의 업로드가 생겼을 경우(파일 이름이 같지만 변경되었을 때가 있음)
              if (oldValue !== newValue || cellColMeta.propertyType == this.PROPERTY_TYPE.FILE.value || cellColMeta.propertyType == this.PROPERTY_TYPE.IMAGE.value) {
                console.log(`Cell changed! add Stack - Row: ${row}, Column: ${prop}, From: ${oldValue}, To: ${newValue}, Type : ${cellColMeta.propertyType}`);
                const rowId = this.hotInstance.getDataAtCell(row, DEFAULT_COL_INDEX.rowId);//rowId 가져오기
                const experimentId = this.hotInstance.getDataAtCell(row, DEFAULT_COL_INDEX.experimentId);//experimentId 가져오기

                if ((cellColMeta.data == null || cellColMeta.data == '')
                    && (rowId == null || rowId == '')
                    && (experimentId == null || experimentId == '')
                ) {
                  alert(`데이터가 정상적이지 않습니다. 관리자에게 문의해주세요\n afterChange : cellMeta = ${JSON.stringify(cellRowMeta)}`);
                  location.reload();
                  return;
                }
                this.addChangeStack(experimentId, rowId, cellColMeta.data, newValue);
              }
            });

          }
        }), // 데이터가 변경될 때마다 백업
      }
    };
  },
  computed: {
    ...Hub.mapGetters(['getExperimentTypePopFlag','getSelectedExperiment','getSelectedReleaseProcess'
      ,'getFilteredExperimentList','getExperimentResultMode','getCustomSettings','getEditorLayoutClass']),
    ...CommNew.mapGetters(['editDuration','DIAGRAM']),
    ...ProcessEditor.mapGetters(['getSelectedNode']),
  },
  watch: {
    changeStack: {
      deep: true,
      async handler(value) {
        console.log('changeStack =',value)
      }
    },
    mode: {
      deep: true,
      async handler(value) {
        //console.log('[ExperimentResult.vue]watch mode!= ',value)
        this.hotInstance.updateSettings({
          readOnly: value != 'edit' ? true : false,
          manualRowMove: value != 'edit' ? false : true,
        });
        if(value == 'edit'){
          // 자동 저장 시작
          this.startAutoSave();
          await this.polling();
        }
      }
    },
    getSelectedReleaseProcess :{
      deep: true,
      async handler(value) {
        //console.log('[ExperimentResult.vue]getSelectedReleaseProcess= ',value)
        if(value?.idReleaseProcess != null && value?.idReleaseProcess > 0){
          //await this.fetchReleaseProcessPropertyListOfProcess({processId : this.$route.query.processId})
          await this.fetchCustomSettings(this.$route.query.processId);
          await this.initializeTable();
        }
      }
    },
    getFilteredExperimentList: {
      deep: true,
      async handler(value) {
        try {
          if(value.length > 0 && this.$route.path.includes('experiment')){
            const processPropList = await this.$wApi.property.getAllReleaseProcessPropertyList({
                processId : this.$route.query.processId
                ,experimentId : this.getFilteredExperimentList[0].experimentId
            });
            if(!processPropList.error){
              this.selectedAddRowInfo = processPropList;
              this.selectOption = this.getFilteredExperimentList[0].experimentId;
              this.selectKey++;
            }
          }
        }catch (e){
          console.log('ExperimentResult getFilteredExperimentList', e)
        }
      }
    },
    getSelectedNode: {
      deep: true,
      async handler(node) {
        const columns = this.hotInstance.getSettings().columns;
        let columnsToSelect = [];
        /*col.propertyVisible || col.propertyVisible == undefined 커스텀 설정을 했을경우 true 설정 없는 경우 undefined*/
        columns.filter(col => node.key == col.key && (col.propertyVisible || col.propertyVisible == undefined)).forEach(target => {
          const colIndex = columns.findIndex(col => col.data == target.data)
          columnsToSelect.push(colIndex)
        });

        if (columnsToSelect.length === 1 && this.getEditorLayoutClass == 'layout_type_4') {
          // 배열에 값이 하나일 경우 해당 열만 선택
          this.hotInstance.selectColumns(columnsToSelect[0]);
        } else if (columnsToSelect.length > 1 && this.getEditorLayoutClass == 'layout_type_4') {
          // 배열에 값이 두 개 이상일 경우 최소값과 최대값을 구해 범위 선택
          const min = Math.min(...columnsToSelect);
          const max = Math.max(...columnsToSelect);
          this.hotInstance.selectColumns(min, max);
        }
      }
    },
  },
  async mounted() {
  },
  methods: {
    ...Hub.mapMutations(
        [
          "setHotInstance",
          "setResultConfirmPopFlag",
          "setNodeMarkSettingPopFlag",
          "setFileUploadObj",
          "setExperimentResultMode",
          "setExperimentTypePopFlag",
          "setSaveHistoryObj",
          "setVersionHistoryPopFlag",
          "setKeshImageServicePopFlag",
        ]
    ),
    ...Hub.mapActions(
        [
          "fetchReleaseProcessPropertyListOfProcess",
          "fetchCustomSettings",
        ]
    ),
    async initializeTable() {
      try {
        this.loading = true;

        //실험데이터와 헤더는 서로 의존하지 않으므로 동시에 조회한다.
        const [experimentDataList, { nestedHeaders, columns, hiddenIndexes }] = await Promise.all([
          this.$wApi.experiment.getExperimentData({
            processId: this.$route.query.processId
          }),
          settingHeader(
            this.$wApi,
            this.$route,
            this.getSelectedReleaseProcess,
            this.getCustomSettings
          )
        ]);
        if(experimentDataList.length > 0) {
          this.cellsFromDB = experimentDataList;
        }
        //console.log('this.cellsFromDB = ',this.cellsFromDB);

        this.hotSettings.nestedHeaders = nestedHeaders;
        //console.log('nestedHeaders',nestedHeaders)
        this.hotSettings.columns = columns;
        //console.log('columns',columns)
        // hotInstance는 hot-table 컴포넌트가 렌더된 이후에 접근 가능
        this.$nextTick(() => {
          this.hotInstance = this.$refs.handsomeRef.hotInstance;
          //console.log("loading savedSorting =",JSON.parse(localStorage.getItem(`sortState_${this.$route.query.processId}`)))
          const savedSorting = JSON.parse(localStorage.getItem(`sortState_${this.$route.query.processId}`));
          this.hotInstance.updateSettings({
            readOnly : this.mode == 'readOnly' ? true : false,
            nestedHeaders : nestedHeaders,
            columns : columns,
            hiddenColumns: {
              columns: [...hiddenIndexes], // 숨길 컬럼의 인덱스
              indicators: false, // 숨긴 열의 표시기(true) 또는 숨기기(false)
              copyPasteEnabled: false, //숨김열의 복사 여부
            },
            multiColumnSorting: {
              indicator: true,
              initialConfig: savedSorting ?? undefined, // 배열의 첫 요소가 있으면 적용, 없으면 undefined
            },
            fixedColumnsStart: 5,
            data: this.buildRowData(this.cellsFromDB, this.hotSettings.columns),
            afterGetColHeader: (col, TH) => {
              //console.log(columns[col])
              // 컬럼별로 헤더 배경색 설정
              // 컬럼 색상 설정
              if (columns[col] && columns[col].tagType) {
                switch (columns[col].tagType) {
                  case "PROCESS":
                    TH.style.backgroundColor = '#D8E5F5';
                    break;
                  case "MATERIAL":
                    TH.style.backgroundColor = '#E2DDE9';
                    break;
                  case "EQUIPMENT":
                    TH.style.backgroundColor = '#DAEDE8';
                    break;
                }
              }

              // headerLevel을 가져오는 로직 (TH 요소의 속성이나 위치를 기반으로)
              const headerRow = TH.parentElement.rowIndex;
              const lastHeaderRow = nestedHeaders.length - 1;

              // 서브 헤더 행이 아닐경우(메인헤더일 경우)
              if (headerRow !== lastHeaderRow) {
                /*정렬 아이콘 제거*/
                const sortIndicators = TH.querySelectorAll('span.colHeader.columnSorting.sortAction');
                sortIndicators.forEach(indicator => {
                  indicator.className = 'colHeader';
                });
                /*필터 아이콘 제거*/
                const filterIndicators = TH.querySelectorAll('button.changeType');
                filterIndicators.forEach(indicator => {
                  indicator.style.display = 'none';
                });
              }
            },//end afterGetColHeader
          });

          //고유ID 초기화
          const {companyName, name} = this.user;
          const uniqueIdCol = this.hotInstance.getSettings().columns.find(col => col.processPropertyType == 'NO');
          initiateUniqueID(this.hotInstance.getSourceData(),uniqueIdCol.data,companyName,name);
          //store에 저장
          this.setHotInstance(this.hotInstance);
          this.hotInstance.render();

          //사용자별 sorting 정보 localstorage 저장.
          this.hotInstance.addHook('afterColumnSort', (currentSortConfig,destinationSortConfigs) => {
            localStorage.setItem(`sortState_${this.$route.query.processId}`, JSON.stringify(destinationSortConfigs));
            //console.log("saving savedSorting =",JSON.parse(localStorage.getItem(`sortState_${this.$route.query.processId}`)))
          });
          //console.log('this.hotInstance',this.hotInstance.getSettings())
          window.addEventListener( 'keydown' , this.keydownHandler ) ;
        });
        // this.$nextTick(() => {
        //   //nestedHeader로 인한 메인헤더 쪽 filter 삭제.
        //   const headerRow = this.$refs.handsomeRef.$el
        //       .querySelectorAll('thead[role="rowgroup"]')[0]
        //       .querySelectorAll('tr')[0];
        //
        //   const buttons = headerRow.querySelectorAll('button.changeType');
        //
        //   buttons.forEach(button => button.remove());
        // })
      } catch (e) {
        console.log(e);
      }finally {
        this.loading = false;
      }
    },
    buildRowData(cellsFromDB, columns) {
      //1. celldata 그룹화 및 row order 기준 정렬. [[key,value],[key,value]]구조
      const cellGroupByRowId = groupBy(cellsFromDB,"rowId").sort((a,b) => a[1][0].createdRowDate - b[1][0].createdRowDate);
      //console.log("cellGroupByRowId not exclusive",JSON.parse(JSON.stringify(cellGroupByRowId)));

      //2.column에 매핑되는 cell 관련 제어(재공개시 없던 신규속성이 추가된경우 or 재공개시 있던 값이 사라진경우)
      //  행마다 컬럼 전체를 훑으면 셀 수가 많을 때 매우 느려지므로 Set 으로 조회한다.
      const columnDataSet = new Set(columns.map(col => col.data));
      const valueColumns = columns.filter(col => col.processPropertyType != 'HIDDEN');
      cellGroupByRowId.forEach(row => {
        const rowId = row[0];
        const cellItemArr = row[1];
        const experimentId = cellItemArr[0].experimentId;
        const ownedColumnData = new Set(cellItemArr.map(cell => COL_PREFIX+cell.processPropertyId));

        //1. 재공개시 없던 신규속성은 빈 값으로 저장되도록 changeStack 에 추가
        valueColumns.forEach(col => {
          if(!ownedColumnData.has(col.data)){
            this.addChangeStack(experimentId,rowId,col.data,'');
          }
        });

        //2. 재공개시 있던 속성이 제거된경우 cell 제거
        row[1] = cellItemArr.filter(cell => columnDataSet.has(COL_PREFIX+cell.processPropertyId));
      });
      //console.log("cellGroupByRowId",cellGroupByRowId);
      //[rowId, cellDataArray] 형태
      this.mappingCellMetaData = cellGroupByRowId;

      const handsonTableData = {};
      cellGroupByRowId.forEach(rowInfo => {
        //console.log('rowInfo',rowInfo);
        if (!handsonTableData[rowInfo[0]]) {
          handsonTableData[rowInfo[0]]= {}; // 새로운 행을 생성
        }
        rowInfo[1].forEach((cell,index) => {
          if(index == 0){
            handsonTableData[rowInfo[0]][COL_PREFIX+'rowId'] = rowInfo[0];
            handsonTableData[rowInfo[0]][COL_PREFIX+'experimentId'] = cell.experimentId;
          }
          handsonTableData[rowInfo[0]][COL_PREFIX+cell.processPropertyId] = cell.value;
        })
      });
      //console.log('handsonTableData buildRowData =',handsonTableData,'\nObject.values(handsonTableData) = ',Object.values(handsonTableData))
      return Object.values(handsonTableData);
    },
    applyCellMetadata(hotInstance) {
      /*미사용.*/
      const rowCount = hotInstance.countRows();
      const colCount = hotInstance.countCols();

      // 각 셀을 순회하면서 메타데이터의 uuid를 확인
      for (let row = 0; row < rowCount; row++) {
        for (let col = 0; col < colCount; col++) {
          if(this.mappingCellMetaData == null) {
            alert("[applyCellMetadata] 오류가 발생하였습니다.");
            location.reload();
            return;
          }
          const metaData = this.mappingCellMetaData[row][1][col];
          hotInstance.setCellMeta(row, col, 'rowId', metaData.rowId);
          hotInstance.setCellMeta(row, col, 'processPropertyId', metaData.processPropertyId);
          hotInstance.setCellMeta(row, col, 'experimentId', metaData.experimentId);
          hotInstance.setCellMeta(row, col, 'uuid', metaData.experimentDataId);
        }
      }
    },
    //선택된 실험타입으로 row추가
    addRowWithValues(position) {
      if(!this.selectedAddRowInfo.length > 0){
       alert("지정된 기본값SET이 없습니다.");
       return;
      }

      this.hotInstance.batch(() => {
        let newRowIndex;
        // 원본 데이터 가져오기
        const rowId = v4();
        const sourceData = this.hotInstance.getSourceData();
        const newRow = {};
        newRow[COL_PREFIX+'rowId'] = rowId;
        newRow[COL_PREFIX+'experimentId'] = this.selectOption;

        this.hotInstance.getSettings().columns.filter(column => column.processPropertyType !='HIDDEN').forEach(column => {
          let value = '';
          let colId = column.data;
          switch (column.processPropertyType) {
            case "NO":
              const {companyCode, name} = this.user;
              value = generateUniqueID(this.hotInstance.getSourceData(),column.data,companyCode,name);
              break;
            case "SAMPLE":
              break;
            case "DATE":
              value = column.defaultDate || new Date().toISOString().split('T')[0].replace(/-/g, '');
              break;
            default:
              //CUSTOM일때.
              const targetProp = this.selectedAddRowInfo.find(prop => COL_PREFIX+prop.processPropertyId == column.data);
              if(column.propertyType == "DATE"){
                value = column.defaultDate;
              }else{
                value = targetProp.propertyValue;
              }
              break;
          }
          // 새로 추가된 행의 각 셀에 값 설정
          newRow[colId] = value;
          this.addChangeStack(this.selectOption,rowId,colId,value);
        });

        switch (position) {
          case "above":
          case "below":
            const selectedRange = this.hotInstance.getSelectedRange(); // 현재 선택된 범위를 가져옴
            if (!selectedRange) {
              alert('Error!')
              return;
            }
            const baseRowIndex = selectedRange[0].from.row;// 기준이 되는 행
            newRowIndex = position === 'above' ? baseRowIndex : baseRowIndex + 1;
            sourceData.splice(newRowIndex, 0, newRow);
            break;
          case "last":
            sourceData.push(newRow);
            break;
          default :
            return;
        }

        // 업데이트된 데이터로 Handsontable 리렌더링
        this.hotInstance.updateSettings({
          data: sourceData,
        });

        this.hotInstance.render(); // 화면 업데이트
      });
    },
    //선택된 실험타입으로 임시값 row추가
    addSampleRowWithValues(position, rowCount = 1) {
      if(this.sampleRowCount > 15){
        window.alert("한번에 추가 가능한 ROW는 15개 입니다.");
        this.sampleRowCount = 15;
        return;
      }
      if(this.sampleRowCount < 1){
        window.alert("추가할 ROW 개수를 1 이상으로 입력해 주세요.");
        this.sampleRowCount = 1;
        return;
      }
      if(!this.selectedAddRowInfo.length > 0){
       alert("지정된 기본값SET이 없습니다.");
       return;
      }
    
      this.hotInstance.batch(() => {
        const sourceData = this.hotInstance.getSourceData();
        const newRows = [];
    
        // 기존 데이터 분석을 위한 헬퍼 함수들
        const getStringValue = (arr) => {
          const validValues = arr.filter(v => v !== null && v !== undefined && v !== '');
          if (validValues.length === 0) return '';
          
          const uniqueValues = [...new Set(validValues)];
          if (uniqueValues.length === 1) {
            return uniqueValues[0];
          } else {
            return validValues[Math.floor(Math.random() * validValues.length)];
          }
        };
    
        const getRandomNumberInRange = (arr) => {
          const numbers = arr.filter(v => v !== null && v !== undefined && v !== '' && !isNaN(v)).map(Number);
          if (numbers.length === 0) return '';
          const min = Math.min(...numbers);
          const max = Math.max(...numbers);
          const hasDecimal = numbers.some(n => n % 1 !== 0);
          if (hasDecimal) {
            const decimalPlaces = Math.max(...numbers.map(n => {
              const str = n.toString();
              return str.includes('.') ? str.split('.')[1].length : 0;
            }));
            return (Math.random() * (max - min) + min).toFixed(decimalPlaces);
          }
          return Math.floor(Math.random() * (max - min + 1)) + min;
        };
    
        const isNumericColumn = (colId) => {
          const values = sourceData.map(row => row[colId]);
          const numericValues = values.filter(v => v !== null && v !== undefined && v !== '' && !isNaN(v));
          const validValues = values.filter(v => v !== null && v !== undefined && v !== '');
          return validValues.length > 0 && numericValues.length / validValues.length > 0.7;
        };
    
        // rowCount만큼 반복
        for (let i = 0; i < rowCount; i++) {
          const rowId = v4();
          const newRow = {};
          newRow[COL_PREFIX+'rowId'] = rowId;
          newRow[COL_PREFIX+'experimentId'] = this.selectOption;
    
          this.hotInstance.getSettings().columns.filter(column => column.processPropertyType !='HIDDEN').forEach(column => {
            let value = '';
            let colId = column.data;
            
            switch (column.processPropertyType) {
              case "NO":
                const {companyCode, name} = this.user;
                // 현재까지 추가된 row들도 포함하여 ID 생성
                value = generateUniqueID([...sourceData, ...newRows], column.data, companyCode, name);
                break;
                
              case "SAMPLE":
                const sampleValues = sourceData.map(row => row[colId]);
                value = getStringValue(sampleValues);
                break;
                
              case "DATE":
                value = column.defaultDate || new Date().toISOString().split('T')[0].replace(/-/g, '');
                break;
                
              default:
                const targetProp = this.selectedAddRowInfo.find(prop => COL_PREFIX+prop.processPropertyId == column.data);
                
                if(column.propertyType == "DATE"){
                  value = column.defaultDate;
                } else {
                  const columnValues = sourceData.map(row => row[colId]);
                  const hasData = columnValues.some(v => v !== null && v !== undefined && v !== '');
                  
                  if (hasData) {
                    if (isNumericColumn(colId)) {
                      value = getRandomNumberInRange(columnValues);
                    } else {
                      value = getStringValue(columnValues);
                    }
                  } else {
                    value = targetProp?.propertyValue || '';
                  }
                }
                break;
            }
            
            newRow[colId] = value;
          });
    
          newRows.push(newRow);
        }
    
        // 모든 row 생성 완료 후 changeStack 한 번에 추가
        newRows.forEach(newRow => {
          const rowId = newRow[COL_PREFIX+'rowId'];
          console.log(rowId);
          Object.keys(newRow).forEach(colId => {
            if(colId !== COL_PREFIX+'rowId' && colId !== COL_PREFIX+'experimentId') {
              this.addChangeStack(this.selectOption, rowId, colId, newRow[colId]);
            }
          });
        });
    
        // 위치에 따라 row 삽입
        switch (position) {
          case "above":
          case "below":
            const selectedRange = this.hotInstance.getSelectedRange();
            if (!selectedRange) {
              alert('Error!')
              return;
            }
            const baseRowIndex = selectedRange[0].from.row;
            const newRowIndex = position === 'above' ? baseRowIndex : baseRowIndex + 1;
            sourceData.splice(newRowIndex, 0, ...newRows);
            break;
          case "last":
            sourceData.push(...newRows);
            break;
          default :
            return;
        }
    
        this.hotInstance.updateSettings({
          data: sourceData,
        });
    
        this.hotInstance.render();
        this.saveData();
      });
    },
    /*------------------------------------------------------------------------------------------------------------*/
    markRowChanged() {
      this.rowChange = true;
      this.rowChangeVersion += 1;
    },
    getChangeKey(rowId, processPropertyId) {
      return `${rowId}\u0000${processPropertyId}`;
    },
    rebuildChangeStackIndex() {
      this.changeStackIndex = new Map();
      this.changeStack.forEach(change => {
        this.changeStackIndex.set(
          this.getChangeKey(change.rowId, change.processPropertyId),
          change
        );
      });
    },
    addChangeStack(experimentId, rowId, processPropertyId, newValue){
      const processPropId = processPropertyId.replace(COL_PREFIX,'');
      if(processPropId == 'rowId' || processPropId == 'experimentId') return; //숨김컬럼은 데이터 매핑용도
      const changeKey = this.getChangeKey(rowId, processPropId);
      const existingChange = this.changeStackIndex.get(changeKey);
      const nextVersion = ++this.changeVersion;
      if(existingChange){
        existingChange.value = newValue;
        existingChange._version = nextVersion;
      }else{
        const newChange = {
          rowId: rowId
          ,processPropertyId: processPropId
          ,value: newValue
          ,experimentId: experimentId
          ,_version: nextVersion
        };
        this.changeStack.push(newChange);
        this.changeStackIndex.set(changeKey, newChange);
      }
    },
    addFileCopyStack(sourceMappingKey, targetMappingKey, experimentId, rowId, colId, propertyType, targetRow, targetCol) {
      // 동일한 target 셀의 기존 요청 제거 (최신 것만 유지)
      const existingIndex = this.fileCopyStack.findIndex(
        item => item.experimentId === experimentId && 
                item.rowId === rowId && 
                item.colId === colId
      );
      
      if (existingIndex !== -1) {
        this.fileCopyStack.splice(existingIndex, 1);
      }
      
      const oldValue = this.hotInstance.getDataAtCell(targetRow, targetCol);
      
      // 새로운 복사 요청 추가
      this.fileCopyStack.push({
        sourceMappingKey: sourceMappingKey,
        targetMappingKey: targetMappingKey,
        experimentId: experimentId,
        rowId: rowId,
        colId: colId,
        propertyType: propertyType,
        targetRow: targetRow,  // 복원용
        targetCol: targetCol,  // 복원용
        oldValue: oldValue     // 백업값
      });
      
    },
    jsonHandler(){
      exportToJson(this.hotInstance);
    },
    async saveData() {
      // 다른 작업이 진행 중이라면 대기
      if (this.isSaving) {
        window.wToast("이전 저장로직이 실행중입니다. 완료 후 다시 저장해주세요.", {
          variant: "dark-gray",
        }) ;
        return;
      }
      this.isSaving = true;
      this.savingLoading = true;
      try {
        //동시수정 방지. editKey로 유효한 키인지 확인 => 유효하지않을 경우 저장X
        const res = await this.$wApi.simultaneous.saveable({
          editKey: this.editKey
        });
        if (!res.isSaveable) {
          alert("키가 유효하지않습니다.");
          await this.endEditExperiment();
          return;
        }

        // 저장 대상으로 잡힌 파일 복사만 제거하여 저장 중 새로 추가된 요청을 보존한다.
        const pendingFileCopyEntries = [...this.fileCopyStack];
        const pendingFileCopySet = new Set(pendingFileCopyEntries);
        const fileCopyToSave = pendingFileCopyEntries.map(fileCopy => ({...fileCopy}));

        // 파일 복사가 있으면 먼저 처리
        if(fileCopyToSave.length > 0) {
          const fileCopyRes = await this.$wApi.file.copyFileMappings({
            processId: this.$route.query.processId,
            fileCopyRequests: fileCopyToSave
          });

          const hasNewerFileCopy = copiedFile => this.fileCopyStack.some(current =>
            !pendingFileCopySet.has(current) &&
            current.experimentId === copiedFile.experimentId &&
            current.rowId === copiedFile.rowId &&
            current.colId === copiedFile.colId
          );

          if(fileCopyRes.error) {
            await window.alert(fileCopyRes.message);
            fileCopyToSave.forEach(copiedFile=>{
              if (hasNewerFileCopy(copiedFile)) return;
              const targetRow = this.findRowByRowId(copiedFile.rowId);
              const targetCol = this.findColByColId(copiedFile.colId);
              if (targetRow < 0 || targetCol < 0) return;
              this.hotInstance.setDataAtCell(targetRow, targetCol, copiedFile.oldValue, 'revert');
              this.addChangeStack(
                copiedFile.experimentId,
                copiedFile.rowId,
                copiedFile.colId,
                copiedFile.oldValue
              );
            });
          }else{
            fileCopyToSave.forEach(copiedFile=>{
              if (hasNewerFileCopy(copiedFile)) return;
              const targetRow = this.findRowByRowId(copiedFile.rowId);
              const targetCol = this.findColByColId(copiedFile.colId);
              if (targetRow < 0 || targetCol < 0) return;
              const cellValue = this.hotInstance.getDataAtCell(targetRow, targetCol);
              // changeStack에 추가 (DB 저장용)
              this.addChangeStack(
                copiedFile.experimentId,
                copiedFile.rowId,
                copiedFile.colId,
                cellValue
              );
            });
          }
          this.fileCopyStack = this.fileCopyStack.filter(fileCopy => !pendingFileCopySet.has(fileCopy));
        }

        // 값과 버전을 함께 스냅샷하여 저장 중 같은 셀의 추가 변경을 보존한다.
        const deferredFileCopyKeys = new Set(this.fileCopyStack.map(fileCopy =>
          this.getChangeKey(fileCopy.rowId, fileCopy.colId.replace(COL_PREFIX, ''))
        ));
        const pendingChanges = this.changeStack
          .filter(change => !deferredFileCopyKeys.has(
            this.getChangeKey(change.rowId, change.processPropertyId)
          ))
          .map(change => ({
            key: this.getChangeKey(change.rowId, change.processPropertyId),
            version: change._version,
            payload: {
              rowId: change.rowId,
              processPropertyId: change.processPropertyId,
              value: change.value,
              experimentId: change.experimentId,
            }
          }));
        const changesToSave = pendingChanges.map(change => change.payload);
        const rowChangeVersionToSave = this.rowChangeVersion;
        const activeRowListToSave = checkActiveRow(this.hotInstance);

        if(!this.rowChange && changesToSave.length == 0) return;

        const saveRes = await this.$wApi.experiment.saveExperimentData({
          activeRowList : activeRowListToSave,
          processId : this.$route.query.processId,
          experimentLogFlag : "SAVE",
          releaseExperimentDataList : changesToSave,
          logMemo : "",
        });
        if(!saveRes.error){
          window.wToast("실험데이터 자동저장을 완료하였습니다.", {
            variant: "wtoast-bg",
          }) ;
          //초기화
          if (this.rowChangeVersion === rowChangeVersionToSave) {
            this.rowChange = false;
          }
          const savedChangeVersions = new Map(
            pendingChanges.map(change => [change.key, change.version])
          );
          this.changeStack = this.changeStack.filter(change => {
            const changeKey = this.getChangeKey(change.rowId, change.processPropertyId);
            return !savedChangeVersions.has(changeKey)
              || savedChangeVersions.get(changeKey) !== change._version;
          });
          this.rebuildChangeStackIndex();
        }

      } catch (e) {
        console.log('saveData Error!!', e)
      } finally {
        this.isSaving = false; // 저장 작업 종료
        this.savingLoading = false;
      }
    },
    toggleAutoSave() {
      this.isAutoSaveEnabled = !this.isAutoSaveEnabled;
      if (this.isAutoSaveEnabled) {
        // 자동 저장 시작
        this.startAutoSave();
        window.wToast("자동 저장이 활성화되었습니다.", {
          variant: "wtoast-bg",
        });
      } else {
        // 자동 저장 중지
        this.stopAutoSave();
        window.wToast("자동 저장이 비활성화되었습니다.", {
          variant: "dark-gray",
        });
      }
    },
    startAutoSave() {
      // 자동 저장 시작
      if(this.mode == 'readOnly')return;
      if (!this.autoSaveTimer) {
        this.autoSaveTimer = setInterval(async () => {
          if (!this.isSaving && (this.changeStack.length > 0 || this.rowChange)) {
            await this.saveData();
          }
        }, this.autoSaveInterval);
      }
    },
    stopAutoSave() {
      // 자동 저장 중지
      if (this.autoSaveTimer) {
        clearInterval(this.autoSaveTimer);
        this.autoSaveTimer = null;
      }
    },
    callResultConfrim(){
        if(this.isAutoSaveEnabled){
            this.$refs.checkbox_toggle.click();
        }
      this.setResultConfirmPopFlag(true);
    },
    callNodeMarkSetting(){
      this.setNodeMarkSettingPopFlag(true);
    },
    callVersionHistory(){
      this.setVersionHistoryPopFlag(true);
    },
    callKeshImageService(){
      this.setKeshImageServicePopFlag(true);
    },
    async settingAddRowInfo(event){
      this.loading = true;
      try {
        this.selectOption = event.target.value;
        if(this.selectOption == null || this.selectOption <= 0)return;
        const processPropList = await this.$wApi.property.getAllReleaseProcessPropertyList({
            processId : this.$route.query.processId
            ,experimentId : this.selectOption
        });
        this.selectedAddRowInfo = processPropList;
        //console.log('[settingAddRowInfo]processPropList = ', processPropList)
      }catch (e){
        console.log('settingAddRowInfo Error!!',e)
      }finally {
        this.loading = false;
      }
    },
    async excelVocabClassDownLoad() {
      try {
        await this.saveData();
        await window.alert("이 엑셀 파일은 업로드로 활용 불가능한 엑셀 파일입니다.");
        this.loading = true;
        const response = await this.$wApi.experiment.downloadVocabClassExcel({processId: this.$route.query.processId}, null, {responseType: 'blob'});
        const url = window.URL.createObjectURL(response.data);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = this.getSelectedReleaseProcess.name.replace(/<[^>]*>?/g,'')+"_표준어휘체계_"+getFormattedTodayDate()+'.xlsx';
        //console.log(this.getSelectedReleaseProcess)
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.log('download Error!', e);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async excelTemplateDownLoad() {
      try {
        await this.saveData();
        this.loading = true;
        const response = await this.$wApi.experiment.downloadExcelTemplate({processId: this.$route.query.processId}, null, {responseType: 'blob'});
        const url = window.URL.createObjectURL(response.data);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = this.getSelectedReleaseProcess.name.replace(/<[^>]*>?/g,'')+"_"+getFormattedTodayDate()+'.xlsx';
        //console.log(this.getSelectedReleaseProcess)
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.log('download Error!', e);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    editExperiment() {
      this.$emit('editExperiment');
    },
    async endEditExperiment(){
      if (!this.networkErrorCount > 0) {
        const flag = await confirm("저장하지않은 데이터는 삭제됩니다. 저장하시겠습니까?");
        if(flag){
          await this.saveData();
        }
        this.pollingEndSwitch = true;
        //key update.
        const keyResponse = await this.$wApi.simultaneous.statusUpdate({
          relativeId: this.$route.query.processId,
          editType: "EXPERIMENT",
          editable: true, //수정가능상태로 변경
        });
      }
      this.setExperimentResultMode("readOnly");
      this.editStatusAlert = false;
      this.$router.go( this.$router.currentRoute ) ;
    },
    async aliveCheck() {
      try {
        this.loading = true;
        // 서버에 수정 상태 확인 요청
        const response = await this.$wApi.simultaneous.aliveCheck({
          relativeId: this.$route.query.processId,
          editKey: this.editKey,
        });
        // 유효하지 않은 수정 키 처리
        if (!response.isEditMode) {
          this.handleSessionInvalid();
          return false;
        }
        // 네트워크 상태 초기화
        this.networkErrorCount = 0;
        return true;
      } catch (error) {
        console.error("aliveCheck Error:", error);
        this.handleNetworkError();
        return false;
      } finally {
        this.loading = false;
      }
    },
    async polling() {
      while (!this.pollingEndSwitch && this.networkErrorCount < this.maxNetworkErrors) {
        //console.log("Polling start: this.networkErrorCount =", this.networkErrorCount);
        try {
          // 딜레이
          await this.timeout(this.getPollingInterval());
          // aliveCheck 실행
          const isAlive = await this.aliveCheck();
          if (this.pollingEndSwitch || this.networkErrorCount >= this.maxNetworkErrors) {
            break; // 수정 키가 유효하지 않거나 오류 발생 시 폴링 종료
          }
        } catch (error) {
          console.error("Polling Error:", error);
        }
      }
      console.log(`Polling 종료! networkErrorCount = ${this.networkErrorCount}`);
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    getPollingInterval() {
      const defaultInterval = 10000; // 10초
      const minInterval = 1000; // 최소 1초
      return Math.max(Math.floor(this.editDuration / 2), minInterval) || defaultInterval;
    },
    handleNetworkError() {
      this.networkErrorCount++;
      console.warn(`네트워크 오류 발생: ${this.networkErrorCount}/${this.maxNetworkErrors}`);
      if (this.networkErrorCount >= this.maxNetworkErrors) {
        this.showAlert(
          "네트워크 연결 실패",
          "네트워크 연결이 5회 실패하였습니다. 네트워크 상태를 확인해주세요."
        );
        this.pollingEndSwitch = true; // 폴링 중단
      } else {
        window.wToast(`네트워크 오류: ${this.networkErrorCount}/${this.maxNetworkErrors}회 시도`, {
          variant: "red",
        });
      }
    },
    handleSessionInvalid() {
      this.showAlert(
        "유효하지 않은 세션",
        "세션이 만료되었습니다. 새로고침 후 다시 시도해주세요."
      );
      this.pollingEndSwitch = true; // 폴링 종료
    },
    showAlert(title, content) {
      this.editStatusTitle = title;
      this.editStatusContent = content;
      this.editStatusAlert = true;
    },
    async imageViewerLoad(mappingKey){
      this.sourceImageObjects.forEach((imageObj) => {
        URL.revokeObjectURL(imageObj.src); // 메모리 해제
      });

      this.sourceImageObjects = [];

      try {
        this.loading = true;
        const mappingResponse = await this.$wApi.file.getFileMapping({
          mappingKey: mappingKey
        });

        if (mappingResponse.error) {
          alert(`에러발생 ${mappingResponse.message}`);
          return;
        }

        if (mappingResponse.length == 0) {
          alert("이미지 파일이 존재하지 않습니다.");
          return;
        }

        for (let i = 0; i < mappingResponse.length; i++) {
          const response = await this.$wApi.file.download({fileId: mappingResponse[i].fileId}, null, {responseType: 'blob'});
          const url = window.URL.createObjectURL(response.data);
          this.sourceImageObjects.push({
            'src': url, // 이미지 src에 Object URL 추가
            'data-source': url, // 원본 데이터는 'data-source'에 저장
            'alt': mappingResponse[i].originalFileName,
          });
        }

        const $viewer = viewerApi({
          images: this.sourceImageObjects
        })
      } catch (e) {
        alert('오류가 발생했습니다. 관리자에게 문의해주세요.')
      } finally {
        this.loading = false;
      }
    },
    callFileUploadPop(row, col, mappingKey, cellColMeta) {
      this.setFileUploadObj({
        openFlag: true,
        dataObj: {
          mappingTable: "handsontable",
          mappingKey: mappingKey,
          row: row,
          col: col,
          type: cellColMeta.propertyType
        }
      });
    },
    keydownHandler(e) {
      if(this.mode =='readOnly') return false;
      let {ctrlKey, key} = e;
      if (ctrlKey) {
        switch (key) {
          case 's' :
            e.preventDefault();
            this.saveData();
            break;
          case 'r' :
            e.preventDefault();
            this.$router.go(this.$router.currentRoute);
            break;
        }
      }
    },
    async cleanup(){
      this.pollingEndSwitch = true;
      this.setExperimentResultMode("readOnly");
      this.setExperimentTypePopFlag(false);
      this.setResultConfirmPopFlag(false);
      this.setVersionHistoryPopFlag(false);
      this.setKeshImageServicePopFlag(false);
      this.setSaveHistoryObj({
        openFlag: false,
        dataObj: {}
      });
      this.setFileUploadObj({
        openFlag: false,
        dataObj: {}
      });
      this.sourceImageObjects.forEach((imageObj) => {
        URL.revokeObjectURL(imageObj.src); // 메모리 해제
      });
      this.sourceImageObjects = [];
    },
    // 헬퍼 함수들
    findRowByRowId(rowId) {
      const rowCount = this.hotInstance.countRows();
      for(let i = 0; i < rowCount; i++) {
        if(this.hotInstance.getDataAtCell(i, DEFAULT_COL_INDEX.rowId) === rowId) {
          return i;
        }
      }
      return -1;
    },
    
    findColByColId(colId) {
      const columns = this.hotInstance.getSettings().columns;
      return columns.findIndex(col => col.data === colId);
    }
  },
}
</script>

<style lang='scss'>
@import 'viewerjs/dist/viewer.css';
@import "@/style/new/css/cyl.common.css";
@import 'handsontable/dist/handsontable.full.css';
/* Handsontable 선택된 셀 스타일 덮어쓰기 */
.htCore .ht__highlight,
.htCore .ht__highlight .current,
.htCore .current,
.htCore .area,
.htCore .fill {
  font-weight: normal !important;
  font-size: inherit !important;
  border: none !important; /* 선택된 셀의 테두리가 표시되지 않도록 설정 */
}

/* 사용자가 선택한 영역 강조 스타일을 없애기 */
.htCore .ht__area,
.htCore .htBorders div {
  display: none !important;
}
</style>

